import { Component, computed, inject } from "@angular/core"
import { NgOptimizedImage } from "@angular/common"
import { PageToolbarService } from "../../page-toolbar.service"
import { StorageService } from "../../../services/storage.service"

@Component({
  imports: [
    NgOptimizedImage,
  ],
  standalone: true,
  template: `
    <div
      #pageToolbarPlaceholder
      style="width: 100%"
      [style.height.px]="pageToolbarHeight()"
    ></div>
    <div class="column bg-base-100 w-full">
      <div>
        <img [ngSrc]="image1()" alt="image" fill style="position: relative">
      </div>

      <div>
        <img [ngSrc]="image2()" alt="image" fill style="position: relative">
      </div>

      <div>
        <img [ngSrc]="image3()" alt="image" fill style="position: relative">
      </div>
    </div>
  `,
  selector: "e2e-section5-view",
})
export class Section5ViewComponent {
  private storageService = inject(StorageService)

  private pageToolbarService = inject(PageToolbarService)
  pageToolbarHeight = this.pageToolbarService.pageToolbarHeight

  image1 = computed(() => this.storageService.getFileUrl("assets/pages/section5/section5-1.png"))
  image2 = computed(() => this.storageService.getFileUrl("assets/pages/section5/section5-2.png"))
  image3 = computed(() => this.storageService.getFileUrl("assets/pages/section5/section5-3.png"))

}
